import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextBox from '../controls/TextBox';
import CheckBox from '../controls/CheckBox';
import CircularProgress from '../CircularProgress';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { validateEmail } from 'utils';
import { showMessage, handleHTTPError } from 'store/actions';
import timezoneList from 'utils/timezone.json';
import { createClub } from 'apis';
import ComplexSelect from 'components/controls/ComplexSelect';
import './index.scss';
import SelectItem from 'components/controls/SelectItem';
import { Constants } from 'utils/constants';
import GoogleAutoComplete from 'components/controls/GoogleAutoComplete';

class CreateClubDlg extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayName: '',
            email: '',
            mobilePhone: '',
            company: '',
            facility: '',
            password: '',
            confirmPass: '',
            address: '',
            zipCode: '',
            location: undefined,
            allowReservations: true,
            allowCmtyEvent: true,
            allowUserSignUp: false,
            timezone: 'America/Los_Angeles',
            type: Constants.CLUB_TYPE.PHYSICAL,
            orgTags: [],
            validate: false,
            loading: false,
        };
    }

    create = async () => {
        if (this.state.loading) return;
        this.setState({ validate: true });

        if (
            !this.state.displayName ||
            !this.state.email ||
            !validateEmail(this.state.email) ||
            !this.state.company ||
            !this.state.mobilePhone ||
            !this.state.password ||
            !this.state.confirmPass
        ) {
            return;
        }
        if (this.state.password !== this.state.confirmPass) {
            this.setState({ confirmPass: '' });
            return this.props.showMessage({
                show: true,
                message: { text: "Password doesn't be matched", type: 'warning' },
            });
        }
        if (this.state.type === Constants.CLUB_TYPE.PHYSICAL) {
            if (!this.state.address)
                return this.props.showMessage({
                    show: true,
                    message: { text: 'Please add address of club', type: 'warning' },
                });
            if (!this.state.zipCode || !this.state.location)
                return this.props.showMessage({
                    show: true,
                    message: { text: 'Please add correct address of club', type: 'warning' },
                });
        }
        if (!this.state.allowReservations && !this.state.allowCmtyEvent) {
            return this.props.showMessage({
                show: true,
                message: { text: 'Please allow at least one of two feature', type: 'warning' },
            });
        }

        let params = {
            displayName: this.state.displayName,
            email: this.state.email,
            mobilePhone: this.state.mobilePhone,
            company: this.state.company,
            allowReservations: this.state.allowReservations,
            allowCmtyEvent: this.state.allowCmtyEvent,
            allowUserSignUp: this.state.allowUserSignUp,
            timezone: this.state.timezone,
            type: this.state.type,
            orgTags: this.state.orgTags,
            password: this.state.password,
            facility: this.state.facility || undefined,
        };
        if (this.state.type === Constants.CLUB_TYPE.PHYSICAL) {
            params = {
                ...params,
                address: this.state.address,
                zipCode: this.state.zipCode,
                location: this.state.location,
            };
        }

        try {
            this.setState({ loading: true });
            await createClub(params);
            this.props.callback();
            this.cancel();
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: 'New Club has been created.' },
            });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    cancel = () => {
        this.props.toggle();
        this.setState({
            displayName: '',
            email: '',
            mobilePhone: '',
            company: '',
            facility: '',
            password: '',
            confirmPass: '',
            address: '',
            zipCode: '',
            location: undefined,
            allowReservations: true,
            allowCmtyEvent: true,
            allowUserSignUp: false,
            timezone: 'America/Los_Angeles',
            type: Constants.CLUB_TYPE.REAL,
            orgTags: [],
            validate: false,
            loading: false,
        });
    };

    componentDidUpdate = (prevProps) => {};

    completeAddress = ({ address, zipCode, location }) => {
        this.setState({ address, zipCode, location });
    };

    render() {
        const { displayName, email, mobilePhone, company, facility, password, confirmPass } = this.state;

        const getTimeZoneOptions = () => {
            return Object.keys(timezoneList).map((tz) => {
                const hr = Math.round(timezoneList[tz] / 60);
                return { id: tz, name: `${tz} (GMT${hr === 0 ? '' : hr > 0 ? '+' : '-'}${hr})` };
            });
        };

        // const getClubTypeOptions = () => {
        //     return Object.values(Constants.CLUB_TYPE).map((x) => {
        //         return { id: x, name: x.toUpperCase() };
        //     });
        // };

        const getClubTags = () => {
            const iligibleTags = (this.state.orgTags || []).filter((tag) =>
                (this.props.systemSettings.orgTags ?? []).includes(tag),
            );
            return iligibleTags.map((tag) => {
                return { value: tag, label: tag };
            });
        };

        const generateOrgTagsOption = () => {
            return (this.props.systemSettings.orgTags ?? []).map((tag) => {
                return { value: tag, label: tag };
            });
        };

        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.toggle}
                className={this.props.className}
                id="createclub"
            >
                <ModalHeader toggle={this.props.toggle}>
                    Create New Club
                    {this.state.loading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '2px',
                                right: '60px',
                            }}
                        >
                            <CircularProgress />
                        </div>
                    )}
                </ModalHeader>
                <ModalBody className=" position-relative" style={{ zIndex: '1000' }}>
                    <Row>
                        <TextBox
                            label="Display Name"
                            id="displayName"
                            name="displayName"
                            className="col-md-6 mb-3"
                            type="text"
                            required
                            validate={this.state.validate}
                            value={displayName}
                            placeholder="Mt.Tam Racquet Club"
                            onBlur={(e) => {}}
                            onChange={(displayName, e) => {
                                this.setState({ displayName });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Email"
                            id="email"
                            name="email"
                            className="col-md-6 mb-3"
                            type="text"
                            required
                            validate={this.state.validate}
                            value={email}
                            placeholder="club@mail.com"
                            onBlur={(e) => {}}
                            onChange={(email, e) => {
                                this.setState({ email });
                            }}
                            validationOption={{
                                showMsg: false,
                                reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Company"
                            id="company"
                            name="company"
                            className="col-md-6 mb-3"
                            type="text"
                            required
                            validate={this.state.validate}
                            value={company}
                            placeholder="Mt.Tam Racquet Club"
                            onBlur={(e) => {}}
                            onChange={(company, e) => {
                                this.setState({ company });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Mobile Phone"
                            id="mobilePhone"
                            name="mobilePhone"
                            className="col-md-6 mb-3"
                            type="text"
                            required
                            validate={this.state.validate}
                            value={mobilePhone}
                            placeholder="4589762123"
                            onBlur={(e) => {}}
                            onChange={(mobilePhone, e) => {
                                this.setState({ mobilePhone });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <SelectItem
                            label="Time Zone"
                            required
                            className="col-md-6 mb-3"
                            id="timezone"
                            size="sm"
                            value={this.state.timezone}
                            optionList={getTimeZoneOptions()}
                            onChange={(timezone) => {
                                this.setState({
                                    timezone: timezone.id,
                                });
                            }}
                        />
                        <TextBox
                            label="Facility"
                            id="facility"
                            name="facility"
                            type="text"
                            className="col-md-6 mb-3"
                            value={facility}
                            placeholder="Facility"
                            onChange={(facility, e) => {
                                this.setState({ facility });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: false,
                                required: false,
                            }}
                        />
                        {/* <SelectItem
                            label={
                                <label htmlFor="type" className="mb-0">
                                    <span>Type</span>
                                    <span className="ml-1 h5 text-danger">*</span>
                                </label>
                            }
                            className="col-md-6 mb-3"
                            id="type"
                            size="sm"
                            value={this.state.type}
                            optionList={getClubTypeOptions()}
                            onChange={(type) => {
                                this.setState({
                                    type: type.id,
                                    allowReservations:
                                        type.id === Constants.CLUB_TYPE.VIRTUAL ? false : this.state.allowReservations,
                                });
                            }}
                        /> */}
                        {this.state.type === Constants.CLUB_TYPE.PHYSICAL && (
                            <Col md={12} className="mb-3">
                                <GoogleAutoComplete
                                    defaultAddress={this.state.address}
                                    onComplete={this.completeAddress}
                                    label={
                                        <label className="mb-0 " htmlFor="name">
                                            Address <span className="text-danger">*</span>
                                        </label>
                                    }
                                />
                            </Col>
                        )}
                        <Col md={4} className="mb-3 text-center">
                            <CheckBox
                                label="Full Reservation Service"
                                id="allowReservations"
                                name="allowReservations"
                                disabled={this.state.type === Constants.CLUB_TYPE.VIRTUAL}
                                checked={this.state.allowReservations}
                                onChange={(allowReservations) => this.setState({ allowReservations })}
                            />
                        </Col>
                        <Col md={4} className="mb-3 text-center">
                            <CheckBox
                                label="Allow Community Events"
                                id="allowCmtyEvent"
                                name="allowCmtyEvent"
                                checked={this.state.allowCmtyEvent}
                                onChange={(allowCmtyEvent) => this.setState({ allowCmtyEvent })}
                            />
                        </Col>
                        <Col md={4} className="mb-3 text-center">
                            <CheckBox
                                label="Allow User Signup"
                                id="allowUserSignUp"
                                name="allowUserSignUp"
                                checked={this.state.allowUserSignUp}
                                onChange={(allowUserSignUp) => this.setState({ allowUserSignUp })}
                            />
                        </Col>

                        <TextBox
                            label="Password"
                            id="password"
                            name="password"
                            type="password"
                            className="col-md-6 mb-3"
                            validate={this.state.validate}
                            required
                            value={password}
                            placeholder="Password"
                            onBlur={(e) => {}}
                            onChange={(password, e) => {
                                this.setState({ password });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <TextBox
                            label="Confirm Password"
                            id="confirmPass"
                            name="confirmPass"
                            type="password"
                            className="col-md-6 mb-3"
                            required
                            validate={this.state.validate}
                            value={confirmPass}
                            placeholder="Password"
                            onBlur={(e) => {}}
                            onChange={(confirmPass, e) => {
                                this.setState({ confirmPass });
                            }}
                            validationOption={{
                                showMsg: false,
                                check: true,
                                required: true,
                            }}
                        />
                        <ComplexSelect
                            placeholder="Select Tags..."
                            label="Organization Tags"
                            className="col-md-12 mb-3"
                            isClearable
                            isMulti
                            value={getClubTags()}
                            options={generateOrgTagsOption()}
                            onChange={(tags) => {
                                this.setState({ orgTags: (tags || []).map((t) => t.value) });
                            }}
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        className="btn-secondary btn btn-lg"
                        style={{ width: '150px' }}
                        onClick={this.cancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        className="btn-primary btn btn-lg"
                        style={{ width: '150px' }}
                        onClick={this.create}
                    >
                        Create
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = ({ user }) => {
    const { systemSettings } = user;
    return { systemSettings };
};

export default connect(mapStateToProps, {
    showMessage,
    handleHTTPError,
})(CreateClubDlg);
